import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkModifyShelterActions from "../../store/actions/BulkModifyShelter";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];
const filterTypes = ["CREATE_SHELTERS", "MAP_AMENITIES"];
const filterTypeSampleCsvUrlMap = {
  CREATE_SHELTERS: "/sample/bulk-upsert-shelters.csv",
  MAP_AMENITIES: "/sample/bulk-map-shelters.csv",
};

const BulkModifyShelterDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="BulkModifyShelterBtn"
      uploadUrl="/bulk-upsert-shelters/ack"
      sampleURL="/sample/bulk-upsert-shelters.csv"
      id="BulkModifyShelterModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Modify Shelters"
      filterTypes={filterTypes}
      getUploadUrl={getBulkUploadUrl}
      filterTypeSampleCsvUrlMap={filterTypeSampleCsvUrlMap}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      BulkModifyShelterActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkModifyShelterDashboard);
